import React from 'react';

import type { HGPokerGameTile } from '@swf/core/types/Poker';

import styles from './Footer.scss';

interface Props {
  attributes: HGPokerGameTile['attributes'];
}

const Footer: React.FC<Props> = ({ attributes }) => (
  <div className={styles.footer} data-testid="footer">
    {attributes.map(({ name, value }) => (
      <div key={name} className={styles.attribute}>
        <div className={styles.attributeName}>{name}</div>
        <div className={styles.attributeValue}>{value}</div>
      </div>
    ))}
  </div>
);

export default Footer;
